import {ApiDate, ApiDateTime} from "platformed-client/types";

export const GIBBERISH_DATE = "\u2660\u2663\u2665 \u2666\u266a, \u266b\u2600\u2601\u2602";

export type DateInput = ApiDateTime | ApiDate;

export function parseDate(date: DateInput | null | undefined): Date | null {
  if (date == null) return null;
  const parsed = new Date(date);
  return isNaN(parsed.getTime()) ? null : parsed;
}
